module.exports = __webpack_public_path__ + "img/FR_Mark_Primary.c8663c90.svg";